import Debug from '@/util/debug';

const debug = Debug('sw-messages');

export const MessageTypes = { // Client -> Worker
  CHANGE_STATUS: 'CHANGE_STATUS',
  GET_STATUS: 'GET_STATUS',
  ADD_HOST_TO_GENERIC_CACHE: 'ADD_HOST_TO_GENERIC_CACHE',
  REMOVE_HOST_FROM_GENERIC_CACHE: 'REMOVE_HOST_FROM_GENERIC_CACHE',
  ADD_HOST_TO_MAP_CACHE: 'ADD_HOST_TO_MAP_CACHE',
  REMOVE_HOST_FROM_MAP_CACHE: 'REMOVE_HOST_FROM_MAP_CACHE',
  SET_MANIFEST: 'SET_MANIFEST',
  VUE_DEVTOOLS: 'vue-devtools-backend',
};

export const sendMessageToSw = (source, payload) => {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    debug.info('sendMessageToSW: %s (%o)', source, payload);
    return new Promise((resolve, reject) => {
      const chan = new MessageChannel();
      chan.port1.onmessage = e => (e.data.error ? reject(e.data.error) : resolve(e.data));
      navigator.serviceWorker.controller.postMessage({ source, payload }, [chan.port2]);
    });
  }

  return Promise.reject('No navigator.serviceWorker');
};

export const changeStatus = mode =>
  sendMessageToSw(MessageTypes.CHANGE_STATUS, mode);

export const getStatus = () =>
  sendMessageToSw(MessageTypes.GET_STATUS);

export const addHostToGenericCache = host =>
  sendMessageToSw(MessageTypes.ADD_HOST_TO_GENERIC_CACHE, host);

export const removeHostFromGenericCache = host =>
  sendMessageToSw(MessageTypes.REMOVE_HOST_FROM_GENERIC_CACHE, host);

export const addHostToMapCache = host =>
  sendMessageToSw(MessageTypes.ADD_HOST_TO_MAP_CACHE, host);

export const removeHostFromMapCache = host =>
  sendMessageToSw(MessageTypes.REMOVE_HOST_FROM_MAP_CACHE, host);

export const setManifest = config =>
  sendMessageToSw(MessageTypes.SET_MANIFEST, config);



// WEBPACK FOOTER //
// ./src/util/sw-messages.js